export default "__VITE_ASSET__leiZcvlr__"